import NchLogoBase from "./FieldTypeBase/NchLogoBase";
import Col from '../Col2.js';
const NchLogoBlock = (props) => {

    return(
        <Col key={props.objectkey} 
            {...props}
            id={props.objectkey}            
            className={` ${props.field.class || ""} 
                        col-md-${props.field.width} 
                        `}          >

            <NchLogoBase {...props} />
            
        </Col>
    );
}

export default NchLogoBlock;